export default {
   path: '/multicotizador/automotor',
   children: [
      //TODO: agregar beforeEnter en todas las rutas hijas si es necesario
      {
         path: '',
         name: 'automotor',
         component: () => import('../views/AutomotorView.vue'),
         // beforeEnter: (to, from, next) => {
         //    if (store.state.poliza.poliza.id_poliza === null) {
         //       store.commit('main/resetClientData');
         //       next('/menu');
         //       return;
         //    }
         //    next();
         // },
      },
      {
         path: 'cotizaciones',
         name: 'automotor/cotizaciones',
         component: () => import('../views/CotizacionesView.vue'),
      },
      {
         path: 'emision',
         name: 'automotor/emision',
         component: () => import('../views/EmisionView.vue'),
      },
      {
         path: 'confirmacion-emision',
         name: 'automotor/confirmacion-emision',
         component: () => import('../views/ConfirmacionEmisionView.vue'),
      },
   ],
};
